(function () {
  'use strict';
 
  var EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  class NewsletterForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.input = this.querySelector('[data-newsletter-input]');
      this.errorEl = this.querySelector('[data-newsletter-error]');
      if (!this.form || !this.input) return;
      this.form.noValidate = true;

      this.onSubmit = this.onSubmit.bind(this);
      this.onInput = this.onInput.bind(this);

      this.form.addEventListener('submit', this.onSubmit, true);
      this.input.addEventListener('input', this.onInput);
    }

    disconnectedCallback() {
      if (this.form) this.form.removeEventListener('submit', this.onSubmit, true);
      if (this.input) this.input.removeEventListener('input', this.onInput);
    }

    onSubmit(event) {
      if (this.validate()) return;
      event.preventDefault();
      event.stopImmediatePropagation();
    }

    onInput() {
      this.clearError();
    }

    /** Returns true when the form may proceed. */
    validate() {
      var email = (this.input.value || '').trim();
      if (!email || !this.input.checkValidity() || !EMAIL_PATTERN.test(email)) {
        return this.fail();
      }
      this.clearError();
      return true;
    }

    fail() {
      var message = this.dataset.errorText || '';
      if (this.errorEl && message) {
        this.errorEl.textContent = message;
        this.errorEl.hidden = false;
        if (this.errorEl.id) this.input.setAttribute('aria-describedby', this.errorEl.id);
      }
      this.input.setAttribute('aria-invalid', 'true');
      this.input.focus();
      return false;
    }

    clearError() {
      if (this.errorEl && !this.errorEl.hidden && this.errorEl.hasAttribute('data-newsletter-error')) {
        this.errorEl.hidden = true;
        this.errorEl.textContent = '';
      }
      this.input.removeAttribute('aria-invalid');
    }
  }

  if (!customElements.get('newsletter-form')) {
    customElements.define('newsletter-form', NewsletterForm);
  }
})();
